const normalizeToken = (value) => String(value || '').trim();
const normalizeLookup = (value) => normalizeToken(value).toLowerCase();

export const buildSiteCatalog = (sites = []) => {
  const byId = new Map();
  const byCode = new Map();
  const byName = new Map();
  (Array.isArray(sites) ? sites : []).forEach((site) => {
    const id = normalizeToken(site?.id);
    const code = normalizeToken(site?.code);
    const name = normalizeToken(site?.name);
    if (id) byId.set(id, site);
    if (code) byCode.set(code, site);
    if (name) byName.set(normalizeLookup(name), site);
  });
  return { byId, byCode, byName };
};

export const resolveCanonicalSiteIdentity = (source = {}, catalog = null) => {
  const rawSiteId = normalizeToken(source?.site_id || source?.siteId);
  const rawCandidates = [
    rawSiteId,
    normalizeToken(source?.site_code),
    normalizeToken(source?.code),
    normalizeToken(source?.site),
    normalizeToken(source?.site_name),
    normalizeToken(source?.siteName),
    normalizeToken(source?.location),
    normalizeToken(source?.address),
    normalizeToken(source?.name),
  ].filter(Boolean);

  const catalogById = catalog?.byId instanceof Map ? catalog.byId : null;
  const catalogByCode = catalog?.byCode instanceof Map ? catalog.byCode : null;
  const catalogByName = catalog?.byName instanceof Map ? catalog.byName : null;

  const resolveSiteDoc = (token) => {
    if (!token) return null;
    if (catalogById?.has(token)) return catalogById.get(token);
    if (catalogByCode?.has(token)) return catalogByCode.get(token);
    const lookup = normalizeLookup(token);
    if (catalogByName?.has(lookup)) return catalogByName.get(lookup);
    return null;
  };

  let matchedSite = null;
  for (const token of rawCandidates) {
    matchedSite = resolveSiteDoc(token);
    if (matchedSite) break;
  }

  const site_id = normalizeToken(matchedSite?.id || rawSiteId || '');
  const site_name = normalizeToken(
    matchedSite?.name
      || source?.site_name
      || source?.siteName
      || source?.site
      || source?.location
      || source?.address
      || site_id
      || ''
  );

  return {
    site_id: site_id || null,
    site_name: site_name || null,
  };
};

